/* eslint-disable react/no-did-mount-set-state */
import React, { Component } from 'react'
import uuidv4 from 'uuid/v4'

import Module from '~/components/Module'
import SVG from '~/components/SVG'
import { universalOpenUrl } from '~/utils'
import talkIcon from '~/assets/icon-suggest.svg'
import arrowDownIcon from '~/assets/icon-arrow-down.svg'
import TalkItem from './TalkItem'
import styles from './index.css'

export default class TalkModule extends Component {
  state = {
    expanded: false,
    talkData: [],
    allTalkData: [],
    talkLength: 0,
  }

  componentDidMount() {
    const { talkData: allTalkData } = this.props
    this.setState({
      talkLength: allTalkData.length,
      talkData: allTalkData.slice(0, 3),
      allTalkData,
    })
  }

  handleClick = url => {
    universalOpenUrl(url)
  }

  changeExpanded = () => {
    const { expanded, allTalkData } = this.state
    this.setState({
      expanded: !expanded,
      talkData: expanded ? allTalkData.slice(0, 3) : allTalkData,
    })
  }

  render() {
    const { talkData, talkLength, expanded } = this.state

    if (!talkData || !talkLength) {
      return null
    }

    return (
      <Module
        headerIcon={
          <SVG src={talkIcon} width={14} height={14} fill="#0084ff" />
        }
        headerText="推荐阅读"
      >
        {talkData.map(item => (
          <TalkItem
            key={`talkItem-${uuidv4()}`}
            data={item}
            onClick={this.handleClick}
          />
        ))}
        {talkLength > 3 && (
          <div
            className={
              expanded ? styles.textShrinkButton : styles.textExpandButton
            }
            onClick={this.changeExpanded}
          >
            {expanded ? '收起' : '展开更多'}
            <SVG src={arrowDownIcon} width={9} height={5} />
          </div>
        )}
      </Module>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Talk/index.js